var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAwesomeExchangeAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.106,
    height: 18.835,
    viewBox: "0 0 24.106 18.835",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exchange-alt",
    "data-name": "Icon awesome-exchange-alt",
    d: "M0,9.21V8.457a1.13,1.13,0,0,1,1.13-1.13H18.08V5.067a1.131,1.131,0,0,1,1.929-.8l3.767,3.767a1.13,1.13,0,0,1,0,1.6L20.009,13.4a1.131,1.131,0,0,1-1.929-.8V10.34H1.13A1.13,1.13,0,0,1,0,9.21Zm22.977,7.157H6.027v-2.26a1.131,1.131,0,0,0-1.929-.8L.331,17.075a1.13,1.13,0,0,0,0,1.6L4.1,22.439a1.131,1.131,0,0,0,1.929-.8V19.38h16.95a1.13,1.13,0,0,0,1.13-1.13V17.5A1.13,1.13,0,0,0,22.977,16.367Z",
    transform: "translate(0 -3.936)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeExchangeAlt);
export default __webpack_public_path__ + "static/media/Icon-awesome-exchange-alt.8462176bd00d34baa04d8f3e8c3dee07.svg";
export { ForwardRef as ReactComponent };